import {useFormContext, useWatch} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {NFDocumentFooter} from "src/components/Shared/NewForms/NFDocuments/NFDocumentFooter";

export const VendorInvoiceDetailFooter = () => {
    const {t} = useTranslation();
    const {watch} = useFormContext();

    const watchTotalAmount = watch("totalAmount");
    
    return (
        <>
            <NFDocumentFooter>
                <div className={"d-flex"}>
                    <span className={"me-2"}>{t("Total")}:</span> <b>{watchTotalAmount ? watchTotalAmount.toFixed(2) : "-"}</b>
                </div>
            </NFDocumentFooter>
        </>
    )
}